export const visit = "Visit"
export const cleaning = "Cleaning"
export const CleaningCompanies = "Cleaning Companies"
export const Config = "Admin Config"
export const CleanersDashboard = "Dashboard"
export const Help = "Help"
export const Logout = "Logout"
export const DashboardGuide = "Dashboard Guide"
export const ConfigPanelGuide = "Config Panel Guide"